<template>
    <div class="notificacao" id="notificacao-id">
        <b-container fluid class="containerNotificacao" style="padding-left: 0px; padding-right: 0px;">
            <b-row  no-gutters class="notificacaoL1">
                <b-col cols="3" order="1" class="text-center">
                    <i :class="msgRecebida.icone" :style="'color: ' + msgRecebida.cor + ';'" style="font-size: 30px; margin-top: 10px;"></i>
                </b-col>
                <b-col cols="7" order="4" class="text-left">
                    <div class="tituloNotificao"> {{ msgRecebida.descricao }} </div>
                    <div class="naturezaNotificacao">{{ msgRecebida.codigo }} - {{ msgRecebida.apelido }} - {{ msgRecebida.tipo }}</div>
                    <div class="dataNotificacao"> {{ msgRecebida.datahora }}</div>
                </b-col>
                <b-col cols="2" order="11" class="text-center MainInfo-notifica-bot" :id="'MainInfo-notifica-bot-'+ msgRecebida.id" @click="opcoesNotificacao">
                    <div :id="'notiBots1-'+ msgRecebida.id" class="notiBots"><i class="fas fa-ellipsis-v" style="color: #777; font-size: 16px; margin-top: 18px;"></i></div>
                    <div :id="'notiBots2-'+ msgRecebida.id" class="notiBots esconde-notiBots">
                        <div :id="'Lida-'+ msgRecebida.id" class="text-center" style="background: #00AB66; width: 100%; height: 25px;" @click="notificacaoLida">
                            <i class="fas fa-check" style="color: #fff;"></i>
                        </div>
                        <div :id="'Apaga-'+ msgRecebida.id" class="text-center" style="background: #dc3545; width: 100%; height: 25px;" @click="notificacaoApaga">
                            <i class="far fa-trash-alt" style="color: #fff;"></i>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
export default {
    name: 'Notificacao',
    props: {
       notificacaoObj: Object
    },
    data() {
        return { 
            opcoesMenu: false,
            msgRecebida: { },
            clicaApaga: true
        }
    },
    methods: {
        opcoesNotificacao() {
            if(this.clicaApaga) {
                this.opcoesMenu = !this.opcoesMenu;
                
                const tresPontos = document.getElementById('notiBots1-'+ this.msgRecebida.id);
                const Botoes = document.getElementById('notiBots2-' + this.msgRecebida.id);

                if(this.opcoesMenu) {
                    tresPontos.style.transition="opacity 0.5s";
                    tresPontos.style.opacity="0";
                    setTimeout(function(){
                        tresPontos.classList.add("esconde-notiBots");
                    }, 500);
                    Botoes.style.transition="opacity 0.5s";
                    Botoes.style.opacity="1";
                    setTimeout(function(){
                        Botoes.classList.remove("esconde-notiBots");
                    }, 500);
                } else {
                    Botoes.style.transition="opacity 0.5s";
                    Botoes.style.opacity="0";
                    setTimeout(function(){
                        Botoes.classList.add("esconde-notiBots");
                    }, 500);
                    tresPontos.style.transition="opacity 0.5s";
                    tresPontos.style.opacity="1";
                    setTimeout(function(){
                        tresPontos.classList.remove("esconde-notiBots");
                    }, 500);
                }
            }
        },
        notificacaoLida() {
            this.clicaApaga = false;
            this.$emit('lida', this.msgRecebida.id);
        },
        notificacaoApaga() {
            this.clicaApaga = false;
            this.$emit('apaga', this.msgRecebida.id);
        },
        carregaObj() {
            this.msgRecebida.id = this.notificacaoObj.id;
            this.msgRecebida.descricao = this.notificacaoObj.descricao;
            this.msgRecebida.codigo = this.notificacaoObj.codigo;
            this.msgRecebida.apelido = this.notificacaoObj.apelido;
            this.msgRecebida.tipo = this.notificacaoObj.tipo;
            this.msgRecebida.icone = this.notificacaoObj.icone;
            this.msgRecebida.cor = this.notificacaoObj.cor;
            this.msgRecebida.datahora = this.notificacaoObj.datahora[8] + this.notificacaoObj.datahora[9] + '/' + 
                                        this.notificacaoObj.datahora[5] + this.notificacaoObj.datahora[6] + '/' + 
                                        this.notificacaoObj.datahora[0] + this.notificacaoObj.datahora[1] +
                                        this.notificacaoObj.datahora[2] + this.notificacaoObj.datahora[3] + ' - ' +
                                        this.notificacaoObj.datahora[11] + this.notificacaoObj.datahora[12] + ':' + 
                                        this.notificacaoObj.datahora[14] + this.notificacaoObj.datahora[15] + 'h';
        },
        resetOpcoesNotificacao() {
            this.opcoesMenu = false;
            const tresPontos = document.getElementById('notiBots1-'+ this.msgRecebida.id);
            const Botoes = document.getElementById('notiBots2-' + this.msgRecebida.id);
            if(tresPontos !== null && Botoes !== null) {
                Botoes.style.transition="opacity 0.5s";
                Botoes.style.opacity="0";
                setTimeout(function(){
                    Botoes.classList.add("esconde-notiBots");
                }, 500);
                tresPontos.style.transition="opacity 0.5s";
                tresPontos.style.opacity="1";
                setTimeout(function(){
                    tresPontos.classList.remove("esconde-notiBots");
                }, 500);
            }
            this.clicaApaga = true;
        }
    },
    created() {
        this.carregaObj();
        this.$parent.$on('fechouJanela', this.resetOpcoesNotificacao);
    }
}
</script>

<style>
.notificacao {
    position: relative;
    height: 50px;
    width: 100%;
    background: #fff;
    border-bottom: solid 1px rgb(201, 201, 201);
}
.notificacao:hover {
    background: rgba(0, 0, 0, 0.1);
}
.containerNotificacao, .notificacaoL1 {
    margin: 0;
    height: 100%;
}
.MainInfo-notifica-bot, .notiBots {
    height: 100%;
    width: 100%;
}
.esconde-notiBots {
    width: 0px;
    opacity: 0;
    display:none;
}
.tituloNotificao {
    font-size: 12px;
    font-weight: bold;
    color: #777;
}
.naturezaNotificacao {
    font-size: 10px;
    color: #777;
}
.dataNotificacao {
    font-size: 10px;
    color: #777;
    font-weight: bold;
}
</style>